import React from 'react'

interface EmailIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const EmailIcon: React.FC<EmailIconProps> = ({
  color = '#067EB1',
  gradient,
  width = 24,
  height = 18,
  alt = 'Email icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 18'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M.541.592a.625.625 0 01.883-.034l9.643 8.91c.527.487 1.34.487 1.866 0l9.643-8.91a.625.625 0 01.848.918l-9.643 8.91a2.625 2.625 0 01-3.563 0L.577 1.476A.625.625 0 01.54.592z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M22 1.25H2a.75.75 0 00-.75.75v13.28c0 .414.336.75.75.75h20a.75.75 0 00.75-.75V2a.75.75 0 00-.75-.75zM2 0a2 2 0 00-2 2v13.28a2 2 0 002 2h20a2 2 0 002-2V2a2 2 0 00-2-2H2z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default EmailIcon
